export default __webpack_public_path__ + "static/boiler_w.b12914c37df17b6e7278de64353b97aa.svg";